module.exports = __webpack_public_path__ + "img/home-company.1a1ccb81.svg";